export default __webpack_public_path__ + "static/media/truck-travel@2x.9ff18876.png";